<template>
  <div class="mb-24px" v-if="iframe">
    <div class="image is-16by9" v-html="iframe"></div>
    <prismic-rich-text
      v-if="$prismicText(fragment.primary.video_caption)"
      class="content mt-8px mb-0 is-size-7"
      :field="fragment.primary.video_caption"
    />
  </div>
</template>

<script>
export default {
  props: {
    fragment: Object
  },
  computed: {
    iframe() {
      if (this.fragment.primary.video_embed.html) {
        return this.fragment.primary.video_embed.html.replace('<iframe', '<iframe class="has-ratio"')
      }
      return ''
    }
  }
}
</script>
